import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { Brand } from '~core/models/brand.models';

@Component({
  selector: 'brand-details',
  standalone: false,
  templateUrl: './brand-details.component.html',
  styleUrl: './brand-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandDetailsComponent extends BaseComponent {
  brands = input<Brand>();
}
